export default {
      id: "icon-search-usage",
      viewBox: "0 0 21.85 21.86",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-search",
      toString: function () {
        return this.url;
      }
    }